import React, { createContext, useContext, PropsWithChildren } from 'react';

import { useDynamicTheme } from './useDynamicTheme';

type ThemeContextValue = ReturnType<typeof useDynamicTheme>;

const ThemeContext = createContext<ThemeContextValue | null>(null);

export const ThemeProvider: React.FC<PropsWithChildren<object>> = ({ children }) => {
  const value = useDynamicTheme();

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = (): ThemeContextValue => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme debe usarse dentro de ThemeProvider');
  }
  return ctx;
};
